import { lazy } from 'react';
import {
    RECORDINGS_AUTH,
    READ_PERMISSION,
} from 'src/constants/permissions';
import { PermissionsGuard } from 'src/routing/components';


export const Routes = [
    {
        exact: true,
        guard: PermissionsGuard,
        roles: {
            permission: RECORDINGS_AUTH,
            crud: READ_PERMISSION,
        },
        path: '/management/recordings/:id',
        component: lazy(
            () => import('src/views/recording/RecordingDetailsView')
        ),
    },
    {
        exact: true,
        guard: PermissionsGuard,
        roles: {
            permission: RECORDINGS_AUTH,
            crud: READ_PERMISSION,
        },
        path: '/management/recordings',
        component: lazy(() => import('src/views/recording/RecordingListView')),
    },
];
